module.exports = __webpack_public_path__ + "static/media/plus.39cca8ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plus.svg
// module id = 214
// module chunks = 1